// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function str(prim) {
  return prim;
}

function onChangeEvent(fn, evt) {
  var text = evt.target.value;
  if (fn !== undefined) {
    Curry._1(fn, text);
  }
  return /* () */0;
}

var component = ReasonReact.statelessComponent("Search");

function make(value, onChange, $staropt$star, $staropt$star$1, param) {
  var size = $staropt$star !== undefined ? $staropt$star : "small";
  var className = $staropt$star$1 !== undefined ? $staropt$star$1 : "";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              return React.cloneElement(React.createElement("div", {
                              className: "una-form una-search " + className
                            }), {
                          "data-size": size
                        }, React.createElement("div", {
                              className: "una-form-group--rounded"
                            }, React.createElement("input", {
                                  placeholder: "Buscar",
                                  type: "search",
                                  value: value,
                                  onChange: (function (param) {
                                      return onChangeEvent(onChange, param);
                                    })
                                }), React.createElement("button", {
                                  className: "una-btn",
                                  type: "submit"
                                }, React.createElement("i", {
                                      className: "fa fa-search"
                                    }))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.str = str;
exports.onChangeEvent = onChangeEvent;
exports.component = component;
exports.make = make;
/* component Not a pure module */
